import * as React from "react";
import BaseWSTmp from "./base-ws-tmp";

// website 异常订单消息模板;

interface IAbnormalWSTmpProps {
  // 遗漏订单
  missing?: any;
  // 待审核订单
  noadudit?: any;
  // 满员订单
  full?: any;
  // 异常订单
  abnormal?: any;
  // 占位订单
  placeholder?: any;
}

// 异常消息模板
class AbnormalWSTmp extends React.Component<IAbnormalWSTmpProps, any> {
  constructor(props: IAbnormalWSTmpProps) {
    super(props);
  }

  // 获取异常订单信息
  getContent = () => {
    const { missing, noadudit, full, abnormal, placeholder } = this.props;
    const data = [
      { title: "遗漏订单", num: missing },
      { title: "待审核订单", num: noadudit },
      { title: "满员订单", num: full },
      { title: "异常订单", num: abnormal },
      { title: "占位订单", num: placeholder }
    ];

    const row: any = [];
    let itemTemp: any = [];
    data.forEach((element, index) => {
      itemTemp.push(
        <span className="item__data" key={index}>
          {element.title}：<a>{element.num}</a>
        </span>
      );
      if (index != 0 && (index + 1) % 2 === 0) {
        row.push(
          <div className="detail-item" key={row.length + 1}>
            {itemTemp}
          </div>
        );
        itemTemp = [];
      }
    });

    if (itemTemp.length != 0) {
      row.push(
        <div className="detail-item" key={row.length + 1}>
          {itemTemp}
        </div>
      );
    }

    return (
      <div className="abnormal-notice">
        <div>你的订单：</div>
        <div className="order-detail">{row}</div>
      </div>
    );
  };

  render() {
    return <BaseWSTmp {...this.props} slot={this.getContent()} />;
  }
}

export default AbnormalWSTmp;
